import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const ButtonWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${themeGet('spacing.md')};
`;
